import Vue from 'vue'
import showdown from 'showdown'

const converter = new showdown.Converter()

Vue.filter('md', function (value) {
  if (!value) { return '' }

  return converter.makeHtml(value)
})

Vue.filter('price', function (value) {
  if (!value) return ''
  value = parseFloat(value).toFixed(2)
  return `${value} $`
})

Vue.filter('resources', function (src, type) {
  if (!src) { return '' }

  if (!type) { return '' }

  return `/content/resources/${type}/${src}`
})

Vue.filter('lower', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.toLowerCase()
})

Vue.filter('kebab', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.replace(/([A-Z])([A-Z])/g, '$1-$2')
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase()
})

Vue.filter('replace', function (string, search, replace) {
  return string.replace(search, replace)
})

Vue.filter('hoursArrayToSring', function (hours) {
  if (!hours) { return '' }

  // Already an array
  if (!Array.isArray(hours)) { return hours }

  if (hours.length === 0) { return 'Fermé' }

  let ouput = ''

  for (let i = 0; i < hours.length; i++) {
    if (i > 0) { ouput += ', ' }

    ouput += hours[i]
  }

  return ouput
})

Vue.filter('hoursToHuman', function (hours) {
  if (!hours) { return '' }

  return hours.replace(/-/g, ' à ')
    .replace(/:/g, 'h')
})
